export const GradeOptionSortOrder = [
  'Preschool',
  'Grade PK',
  'Grade K',
  'Early Numeracy',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grades 7-8',
  'Grade 9',
  'Algebra 1',
  'Grades 6-8',
  'Grade 10',
  'Geometry',
  'Grades 9-10',
  'Grade 11',
  'Algebra 2',
  'Grade 12',
  'Grades 11-12',
  'High School - Number and Quantity',
  'High School - Algebra',
  'High School - Functions',
  'Grades 9-12',
  'High School - Geometry',
  'High School - Statistics and Probability',
  'Precalculus',
  'Reception',
  'Year 1',
  'Year 2',
  'Year 3',
  'Year 4',
  'Year 5',
  'Year 6',
  'Year 7',
  'Year 8',
  'Year 9',
  'Year 10',
  'Year 11',
  'Algebra 2 and Trigonometry',
  'Grades 10-11',
  'Probability and Statistics',
  'High School Integrated Math I',
  'High School Integrated Math II',
  'High School Integrated Math III',
  'Pre-Algebra',
  'Grades 9-11',
  'English I',
  'English II',
  'English III',
  'English IV'
];
